import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Download, Truck, Receipt } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, money, fdate, downloadPdf } from "@/lib/api";
import { PageHeader, StatusBadge, TableWrap, Th, Td, Empty } from "@/components/common";
import { Button } from "@/components/ui/button";

export default function Orders() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const load = () => api.get("/orders").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const deliver = async (o) => {
    try { await api.post(`/orders/${o.id}/status`, { status: "livree" }); toast.success("Commande marquée livrée"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const invoice = async (o) => {
    try { const r = await api.post(`/orders/${o.id}/invoice`, { due_days: 30 }); toast.success(`Facture ${r.data.number} générée avec succès`); navigate("/factures"); }
    catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div>
      <PageHeader kicker="Gestion commerciale" title="Commandes" />
      {items.length ? (
        <TableWrap>
          <thead><tr><Th>N°</Th><Th>Devis</Th><Th>Client</Th><Th>Date</Th><Th className="text-right">Total TTC</Th><Th>Statut</Th><Th className="text-right">Actions</Th></tr></thead>
          <tbody>
            {items.map((o) => (
              <tr key={o.id} data-testid={`order-row-${o.number}`} className="hover:bg-slate-50">
                <Td className="font-mono text-xs">{o.number}</Td>
                <Td className="font-mono text-xs text-slate-500">{o.quote_number}</Td>
                <Td className="font-medium">{o.client_name}</Td>
                <Td>{fdate(o.created_at)}</Td>
                <Td className="text-right font-semibold">{money(o.total)}</Td>
                <Td><StatusBadge status={o.status} testId={`order-status-${o.number}`} /></Td>
                <Td className="text-right">
                  <div className="flex justify-end gap-1.5">
                    <Button size="sm" variant="outline" title="Bon de commande PDF" data-testid={`order-pdf-${o.number}`} onClick={() => downloadPdf(`/orders/${o.id}/pdf`, `${o.number}.pdf`)}><Download className="h-3.5 w-3.5" /></Button>
                    {o.status === "en_cours" && <Button size="sm" variant="outline" data-testid={`order-deliver-${o.number}`} onClick={() => deliver(o)}><Truck className="mr-1 h-3.5 w-3.5" /> Livrée</Button>}
                    {o.status !== "facturee" && <Button size="sm" className="bg-red-600 hover:bg-red-700" data-testid={`order-invoice-${o.number}`} onClick={() => invoice(o)}><Receipt className="mr-1 h-3.5 w-3.5" /> Facturer</Button>}
                    {o.invoice_number && <span className="self-center font-mono text-xs text-slate-500">{o.invoice_number}</span>}
                  </div>
                </Td>
              </tr>
            ))}
          </tbody>
        </TableWrap>
      ) : <Empty testId="orders-empty" text="Aucune commande. Les commandes sont créées à partir des devis validés par la direction." />}
    </div>
  );
}
